import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("intellix_token", data.token);
      localStorage.setItem("intellix_user", JSON.stringify(data.user));
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Identifiants incorrects");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-[70vh] items-center justify-center px-5 pt-24" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <p className="text-sm font-semibold uppercase tracking-[0.3em] text-primary">Administration</p>
          <h1 className="mt-3 font-display text-2xl font-semibold tracking-tight">Connexion</h1>
        </div>
        <form onSubmit={submit} className="rounded-2xl border border-border/70 bg-card/60 p-6 space-y-5" data-testid="admin-login-form">
          {error && <p className="rounded-xl bg-destructive/10 px-4 py-3 text-sm text-destructive" data-testid="admin-login-error">{error}</p>}
          <label className="grid gap-2 text-sm font-medium">
            Email
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="admin@intellix.fr" className="h-11 rounded-xl" data-testid="admin-email-input" />
          </label>
          <label className="grid gap-2 text-sm font-medium">
            Mot de passe
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="Mot de passe" className="h-11 rounded-xl" data-testid="admin-password-input" />
          </label>
          <Button type="submit" disabled={loading} className="h-11 w-full rounded-full font-semibold" data-testid="admin-login-submit">
            {loading ? "Connexion..." : "Se connecter"} <LogIn className="h-4 w-4" />
          </Button>
        </form>
      </div>
    </div>
  );
}
